import { createAction, createSlice } from '@reduxjs/toolkit';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';

const authSlice = createSlice({
    name: '@auth',
    initialState: {
        getAppUserStatus: REQUEST_STATUS.NOT_REQUESTED,
        getAppUserError: null,
        appUser: {},
        updateNotifyDestinationStatus: REQUEST_STATUS.NOT_REQUESTED,
        updateNotifyDestinationError: null,
    },
    reducers: {
        getAppUserRequest(state) {
            state.getAppUserStatus = REQUEST_STATUS.LOADING;
            state.getAppUserError = null;
            state.appUser = {};
        },
        getAppUserSuccess(state, action) {
            state.getAppUserStatus = REQUEST_STATUS.SUCCESS;
            state.getAppUserError = null;
            state.appUser = action.payload;
        },
        getAppUserError(state, action) {
            state.getAppUserStatus = REQUEST_STATUS.ERROR;
            state.getAppUserError = action.payload;
            state.appUser = {};
        },
        getAppUserReset(state) {
            state.getAppUserStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getAppUserError = null;
            state.appUser = {};
        },
        updateNotifyDestinationRequest(state, _action) {
            state.updateNotifyDestinationStatus = REQUEST_STATUS.LOADING;
            state.updateNotifyDestinationError = null;
        },
        updateNotifyDestinationSuccess(state, action) {
            state.updateNotifyDestinationStatus = REQUEST_STATUS.SUCCESS;
            state.updateNotifyDestinationError = null;
            if (state.appUser) {
                state.appUser.notify_destination = action.payload;
            }
        },
        updateNotifyDestinationFailure(state, action) {
            state.updateNotifyDestinationStatus = REQUEST_STATUS.ERROR;
            state.updateNotifyDestinationError = action.payload;
        },
    },
});

export default authSlice.reducer;

export const logoutRequest = createAction('logout');

export const {
    getAppUserRequest,
    getAppUserSuccess,
    getAppUserError,
    updateNotifyDestinationRequest,
    updateNotifyDestinationSuccess,
    updateNotifyDestinationFailure,
} = authSlice.actions;
